import { createContext, useContext } from "react"

const Context = createContext()
export const Provider = Context.Provider

export function useBanners(){
  return useContext(Context).banners
}

export function useStatic(){
  return !useContext(Context).dynamic
}

export function useDynamic(){
  return useContext(Context).dynamic
}

export function useLocale() {
  return useContext(Context)
}

export function useLocalesByRegions(){
  return useContext(Context).regions
}

export function useDir() {
  return useContext(Context).dir
}

export function useSchema() {
  return useContext(Context).schema
}
